module.exports = __webpack_public_path__ + "img/icb-del-Inte-m@3x.933db005.png";